import React, { useState } from 'react';
import './ReactionTooltip.css';

const ReactionTooltip = ({ reaction, children, currentUserId }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  const getReactorsList = () => {
    if (!reaction.users || reaction.users.length === 0) return '';
    
    const reactors = reaction.users.map(user => {
      if (typeof user === 'object') {
        return user._id === currentUserId ? 'You' : user.displayName;
      }
      return user === currentUserId ? 'You' : 'Someone';
    });

    if (reactors.length === 1) {
      return `${reactors[0]} reacted with ${reaction.emoji}`;
    } else if (reactors.length === 2) {
      return `${reactors[0]} and ${reactors[1]} reacted with ${reaction.emoji}`;
    } else if (reactors.length <= 5) {
      const lastReactor = reactors.pop();
      return `${reactors.join(', ')} and ${lastReactor} reacted with ${reaction.emoji}`;
    } else {
      const firstFew = reactors.slice(0, 3);
      const remaining = reactors.length - 3;
      return `${firstFew.join(', ')} and ${remaining} others reacted with ${reaction.emoji}`;
    }
  };

  return (
    <div 
      className="reaction-tooltip-container"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <div className="reaction-tooltip">
          <div className="reaction-tooltip-content">
            {getReactorsList()}
          </div>
          <div className="reaction-tooltip-arrow"></div>
        </div>
      )}
    </div>
  );
};

export default ReactionTooltip;